import React, { useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { makeStyles } from '@mui/styles';
import { TextField, Card, Grid } from '@mui/material';
import {
	SetFormState
} from '../../actions/DualMapActionsGeneric.js';
import DriveTestChart from './Components/DrivetestChart';

const useStyles = makeStyles((theme) => ({
	root: {
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
	},
	drawer: {
		width: 420,
		maxWidth: '100%',
	},
	header: {
		padding: theme.spacing(2, 1),
		display: 'flex',
		justifyContent: 'space-between',
	},
	buttonIcon: {
		marginRight: theme.spacing(1),
	},
	content: {
		padding: theme.spacing(0, 3),
		flexGrow: 1,
	},
	contentSection: {
		padding: theme.spacing(2, 0),
	},
	contentSectionHeader: {
		display: 'flex',
		justifyContent: 'space-between',
		cursor: 'pointer',
	},
	contentSectionContent: {},
	formGroup: {
		padding: theme.spacing(2, 0),
	},
	fieldGroup: {
		display: 'flex',
		alignItems: 'center',
	},
	field: {
		marginTop: 0,
		marginBottom: 0,
	},
	flexGrow: {
		flexGrow: 1,
	},
	addButton: {
		marginLeft: theme.spacing(1),
	},
	tags: {
		marginTop: theme.spacing(1),
	},
	minAmount: {
		marginRight: theme.spacing(3),
	},
	maxAmount: {
		marginLeft: theme.spacing(3),
	},
	radioGroup: {},
	actions: {
		padding: theme.spacing(3),
		'& > * + *': {
			marginTop: theme.spacing(2),
		},
	},
}));

const AdditionalInfo = (props) => {
	const { className, open, onClose, onFilter, filterDisabled, onClear, data, dataCompare, ...rest } = props;
	const userId = useSelector(state => state.session.user.id);
	const role = useSelector(state => state.session.user.role);
	const classes = useStyles();
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector((state) => state.dualMapReducer.formState);

	const cardStyle = {
		// height: '10vh'
	};

	return (
		<Card style={cardStyle}>
			<div className={classes.content}>
				<div className={classes.contentSection}>
					<Grid container spacing={1}>
						<Grid item md={4}>
							<DriveTestChart id="chartOne" data={data} />
						</Grid>
						<Grid item md={2}>
							<Grid container spacing={1}>
								<TextField
									id="average"
									name="average"
									label="Average"
									InputProps={{
										readOnly: true,
									}}
									variant="outlined"
									value={(data && data.measures.average) || ''}
								/>
							</Grid>
							<br />
							<Grid container spacing={1}>
								<TextField
									id="maximum"
									name="maximum"
									label="Maximum"
									InputProps={{
										readOnly: true,
									}}
									variant="outlined"
									value={(data && data.measures.maximum) || ''}
								/>
							</Grid>
							<br />
							<Grid container spacing={1}>
								<TextField
									id="minimum"
									name="minimum"
									label="Minimum"
									InputProps={{
										readOnly: true,
									}}
									variant="outlined"
									value={(data && data.measures.minimum) || ''}
								/>
							</Grid>
						</Grid>
						<Grid item md={4} hidden={!formState.values.mapCompare}>
							<DriveTestChart id="chartTwo" data={dataCompare} />
						</Grid>
						<Grid item md={2} hidden={!formState.values.mapCompare}>
							<Grid container spacing={1}>
								<TextField
									id="average"
									name="average"
									label="Average"
									InputProps={{
										readOnly: true,
									}}
									variant="outlined"
									value={(dataCompare && dataCompare.measures.average) || ''}
								/>
							</Grid>
							<br />
							<Grid container spacing={1}>
								<TextField
									id="maximum"
									name="maximum"
									label="Maximum"
									InputProps={{
										readOnly: true,
									}}
									variant="outlined"
									value={(dataCompare && dataCompare.measures.maximum) || ''}
								/>
							</Grid>
							<br />
							<Grid container spacing={1}>
								<TextField
									id="minimum"
									name="minimum"
									label="Minimum"
									InputProps={{
										readOnly: true,
									}}
									variant="outlined"
									value={(dataCompare && dataCompare.measures.minimum) || ''}
								/>
							</Grid>
						</Grid>
					</Grid>
				</div>
			</div>
		</Card>
	);
};

AdditionalInfo.propTypes = {
	className: PropTypes.string,
	open: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	onFilter: PropTypes.func.isRequired,
	filterDisabled: PropTypes.bool,
	onClear: PropTypes.func,
	data: PropTypes.array,
	dataCompare: PropTypes.array
};

export default AdditionalInfo;
